import { useQueryParams, useQueryUpdate } from '@shared/hooks'
import { SorterResult } from 'antd/lib/table/interface'

enum OrderType {
  DESCEND = 'descend',
  ASCEND = 'ascend'
}

export const useTableSorter = (): (<T>(
  sorter: SorterResult<T> | SorterResult<T>[]
) => void) => {
  const params = useQueryParams()
  const { updateQuery } = useQueryUpdate()

  const tableSorter = <T>(
    sorter: SorterResult<T> | SorterResult<T>[]
  ): void => {
    const { order, column } = sorter as SorterResult<T>

    const newOrdering = order
      ? `${order === OrderType.DESCEND ? '-' : ''}${column && column.key}`
      : undefined

    const currentOrdering = (params.ordering as string) || undefined

    if (newOrdering === currentOrdering) return

    updateQuery({ ordering: newOrdering ?? null })
  }

  return tableSorter
}
